export default {
  sections: {
    setup_fee: {
      title: "Frais d'installation",
      description: "Frais d'installation à partir de {{amount}} – au lieu de 1 000+",
    },
  },
  labels: {
    month: 'Mois (HT)',
    one_time_fee: 'Frais uniques',
    more_options: "Plus d'options",
    discount_badge: '-{{percentage}}%',
  },
  features: {
    app: "Votre propre application sur l'App Store & Google Play",
    push_notifications: 'Notifications push pour les offres',
    loyalty: 'Fidélisation via des programmes de fidélité',
    offline_orders: 'Commandes hors ligne possibles',
    individual_design: "Design d'application personnalisé",
  },
  setup_fee_options: {
    150: 'Installation standard',
    75: 'Réduit',
    0: 'Pas de frais de création',
  },
  feedback: {
    contract_signed_already: {
      title: 'Le contrat est déjà signé',
      description: "Veuillez contacter le support technique si vous avez besoin d'effectuer des modifications",
    },
  },
};
